import { AvatarDropdown, AvatarName, /*Footer,*/ /*Question,*/ SelectLang } from '@/components';
// import { LinkOutlined } from '@ant-design/icons';
import a7 from '@/assets/a7.svg';
import ChatCom from '@/components/ChatCom/index';
import { currentUser as queryCurrentUser } from '@/services/ant-design-pro/api';
import { getMenus } from '@/services/common';
import * as Icons from '@ant-design/icons';
import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import { SettingDrawer } from '@ant-design/pro-components';
import type { RunTimeLayoutConfig } from '@umijs/max';
import { history, Link } from '@umijs/max';
import { Flex, Splitter } from 'antd';
import React from 'react';
import defaultSettings from '../config/defaultSettings';
import { requestConfig } from './requestConfig';
import WatermarkComponent from './warter'; // 引入水印组件

const isDev = process.env.NODE_ENV === 'development';
const loginPath = '/user/login';

/**
 * @see  https://umijs.org/zh-CN/plugins/plugin-initial-state
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: API.CurrentUser;
  loading?: boolean;
  menuData?: any;
  fetchUserInfo?: () => Promise<API.CurrentUser | undefined>;
}> {
  const fetchUserInfo = async () => {
    try {
      const msg = await queryCurrentUser({
        skipErrorHandler: true,
      });
      return msg.data;
    } catch (error) {
      history.push(loginPath);
    }
    return undefined;
  };

  const getMenusData = async () => {
    return await getMenus();
  };

  // 如果不是登录页面，执行
  const { location } = history;
  if (location.pathname !== loginPath) {
    const currentUser = await fetchUserInfo();
    const menuResponse = await getMenusData();
    const {
      data: { records },
    } = menuResponse || {};
    return {
      fetchUserInfo,
      currentUser,
      menuData: records,
      settings: defaultSettings as Partial<LayoutSettings>,
    };
  }
  return {
    fetchUserInfo,
    menuData: [],
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({ initialState, setInitialState }: any) => {
  const { menuData } = initialState;

  const loopMenuItem = (menus: any) => {
    return menus.map(({ icon, children, ...item }: any) => {
      let Ic;
      if (icon && Icons[icon]) {
        const IconEle = Icons[icon]; // icon名为手动录入
        Ic = <IconEle />;
      }
      return {
        ...item,
        icon: Ic,
        children: children?.length && loopMenuItem(children),
      };
    });
  };

  return {
    actionsRender: () => [, /* <Question key="doc" /> */ <SelectLang key="SelectLang" />],
    avatarProps: {
      src: initialState?.currentUser?.avatar,
      title: <AvatarName />,
      render: (_, avatarChildren) => {
        return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      },
    },
    // headerContentRender: () => <div>search</div>,
    waterMarkProps: {
      // content: initialState?.currentUser?.name,
      // content: 'AptSell',
    },
    // footerRender: () => <Footer />,
    footerRender: undefined,
    onPageChange: () => {
      const { location } = history;
      // 如果没有登录，重定向到 login
      if (!initialState?.currentUser && location.pathname !== loginPath) {
        history.push(loginPath);
      }
    },
    bgLayoutImgList: [
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/D2LWSqNny4sAAAAAAAAAAAAAFl94AQBr',
        left: 85,
        bottom: 100,
        height: '303px',
      },
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/C2TWRpJpiC0AAAAAAAAAAAAAFl94AQBr',
        bottom: -68,
        right: -45,
        height: '303px',
      },
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/F6vSTbj8KpYAAAAAAAAAAAAAFl94AQBr',
        bottom: 0,
        left: 0,
        width: '331px',
      },
    ],
    // links: isDev
    //   ? [
    //       <Link key="openapi" to="/umi/plugin/openapi" target="_blank">
    //         <LinkOutlined />
    //         <span>OpenAPI 文档</span>
    //       </Link>,
    //     ]
    //   : [],
    menuHeaderRender: undefined,
    menuProps: {
      locale: false,
    },
    menuItemRender: (menuItemProps, defaultDom) => {
      if (menuItemProps.isUrl || menuItemProps.children || !menuItemProps.path) {
        return defaultDom;
      }
      return <Link to={menuItemProps.path}>{defaultDom}</Link>;
    },
    menuDataRender: () => loopMenuItem(menuData),
    childrenRender: (children) => {
      // if (initialState?.loading) return <PageLoading />;
      const ChildRender = () => {
        const [sizes, setSizes] = React.useState<(number | string)[]>(['100%', '0']);
        // 显示聊天机器人
        const handleChatVisibleChange = () => {
          if (sizes[1] !== '0') {
            setSizes(['100%', '0']);
          } else {
            setSizes(['72%', '28%']);
          }
        };

        return (
          <>
            <WatermarkComponent />
            <Flex vertical style={{ height: '100vh', width: '99.5%' }}>
              <Splitter onResize={setSizes} style={{ height: '100vh' }}>
                <Splitter.Panel size={sizes[0]} resizable>
                  {children}
                </Splitter.Panel>
                <Splitter.Panel size={sizes[1]} min={200}>
                  <ChatCom onSetChatVisible={handleChatVisibleChange} />
                </Splitter.Panel>
              </Splitter>
            </Flex>
            {isDev && (
              <SettingDrawer
                disableUrlParams
                enableDarkTheme
                settings={initialState?.settings}
                onSettingChange={(settings) => {
                  setInitialState((preInitialState) => ({
                    ...preInitialState,
                    settings,
                  }));
                }}
              />
            )}
          </>
        );
      };
      return <ChildRender />;
    },
    ...initialState?.settings,
    logo: (
      <>
        <img alt="logo" src={a7} />
      </>
    ),
    title: (
      <>
        <span style={{ color: '#4880FF' }}>Diagnosis</span>
      </>
    ),
  };
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request = {
  ...requestConfig,
};
